import './Search.scss';

import Icon from 'components/Icon/Icon';

interface Props {
  onChange: (e: string) => void;
  placeholder?: string;
  value?: string;
}

const Search = ({onChange, value, placeholder = ''}: Props) => {
  return (
    <div className="search">
      <input
        defaultValue={value}
        className="search__field"
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      <Icon icon="search" />
    </div>
  );
};

export default Search;
